var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Portal',{attrs:{"to":"mobile-footer-wrapper"}},[_vm._t("before"),_c('div',{staticClass:"mobile-footer"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }